<div class="container pb-4 pt-4 pe-0 pe-md-2 ps-0 ps-md-2">
  <app-breadcrumb currentRouteName="Informations"></app-breadcrumb>
  <h1 class="pt-4 ps-2 ps-md-0">Fil d'information</h1>

  <div class="infos-grid">
    @if (infos) {
      <div>
        @if (infos.length === 0) {
          <div class="pt-4 pb-4">
            <div class="text-info">
              <fa-icon icon="info-circle"></fa-icon>
              Aucune information en direct ce jour.
            </div>
          </div>
        }
        @if ((infos | infotype:'DIRECT').length > 0) {
          <div>
            <h2 class="ps-2 ps-md-0 pt-3 pb-2">Informations en direct</h2>
            @for (info of infos | infotype:'DIRECT'; track info; let isFirst = $first) {
              <app-info-block [info]="info"
              [isFirst]="isFirst"></app-info-block>
            }
          </div>
        }
        @if ((infos | infotype:'PINNED').length > 0) {
          <div>
            <h2 class="ps-2 ps-md-0 pt-3 pb-2">Informations épinglées</h2>
            @for (info of infos | infotype:'PINNED'; track info) {
              <app-info-block [info]="info"></app-info-block>
            }
          </div>
        }
        @if ((infos | infotype:'HISTORY').length > 0) {
          <div>
            <h2 class="ps-2 ps-md-0 pt-3 pb-2">Historique des informations</h2>
            @for (info of infos | infotype:'HISTORY'; track info) {
              <app-info-block [info]="info"></app-info-block>
            }
          </div>
        }
      </div>
    }
    <div class="d-none flex-column p-56px">
      <app-dash-block-news class="block-shadow bg-white"></app-dash-block-news>
    </div>

  </div>

</div>
